
// Core imports
import React, { forwardRef, Fragment, useEffect, useImperativeHandle, useRef, useState } from 'react';
import PropTypes from 'prop-types';

// Constants
const baseClassName = 'custom-drawer';

//TODO: Can be improved if the need arises to handle more complex configuration

const CustomDrawer = forwardRef(({
  children,
  isVisible = false,
  containerStyle={},
  maxHeightAllowed = 1000,
  elementStyles={}
}, ref) => {

  const drawerRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    if (isVisible) {
      // The actual height is determined from the children
      setMaxHeight(maxHeightAllowed);
    } else {
      setMaxHeight(0);
    }
  }, [isVisible]);

  useImperativeHandle(ref, () => {
    if(drawerRef) {
      return drawerRef;
    } else {
      return null;
    }
  }, [drawerRef]);

  return (
    <Fragment>
      <div
        className={baseClassName}
        ref={drawerRef}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          maxHeight: maxHeight,
          transition: 'max-height 0.5s ease-in-out',
          overflow: 'hidden',
          zIndex: 1000,
          ...elementStyles
        }}
      >
        <div style={containerStyle} className={`${baseClassName}-container`}>
          {children}
        </div>
      </div>
    </Fragment>
  );
});

CustomDrawer.propTypes = {
  children: PropTypes.node.isRequired,
  isVisible: PropTypes.bool,
  containerStyle: PropTypes.object,
  maxHeightAllowed: PropTypes.number,
  elementStyles: PropTypes.object
};

export default CustomDrawer;
